import { IconButtonTestId } from '@xemplo/icon-button';

export const defaultPageSizeOptions = [
  { key: '10', value: '10' },
  { key: '20', value: '20' },
  { key: '30', value: '30' },
  { key: '40', value: '40' },
  { key: '50', value: '50' },
];

export const maxPageSizeOptionsLength = 10;
export const minPageSize = 10;
export const maxPageSize = 100;

export const iconButtonIds = {
  firstPage: 'table-pagination-first-page-btn',
  previousPage: 'table-pagination-previous-page-btn',
  nextPage: 'table-pagination-next-page-btn',
  lastPage: 'table-pagination-last-page-btn',
};

export const PaginationTestId = {
  wrapper: 'table-pagination-wrapper',
  counter: 'table-pagination-counter',
  controls: 'table-pagination-controls',
  pages: 'table-pagination-pages',
  pageSizeSelector: 'table-pagination-page-size-selector',
  iconButton: {
    firstPage: IconButtonTestId.Button(iconButtonIds.firstPage),
    previousPage: IconButtonTestId.Button(iconButtonIds.previousPage),
    nextPage: IconButtonTestId.Button(iconButtonIds.nextPage),
    lastPage: IconButtonTestId.Button(iconButtonIds.lastPage),
  },
};
